export const server = "https://prdschemeserver.appdeploy.in/api/v1";
// export const server = "http://103.189.80.3:6006/api/v1";

import userPic from "./assets/user.png";

export const defaultUserImage = userPic;

export const logo =
  "https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Jharkhand_Police_Logo_%28India%29.svg/1200px-Jharkhand_Police_Logo_%28India%29.svg.png";
